import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({ isOpen, onClick }) => {
  const { t } = useLanguage();

  return (
    <button
      className={`hamburger-btn ${isOpen ? 'open' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? t('mapControls.closeMenu') : t('mapControls.openMenu')}
      aria-expanded={isOpen}
    >
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
    </button>
  );
};

export default HamburgerButton;
